import { useState } from "react";
import {
  Collapse,
  IconButton,
  Stack,
  Typography,
  useTheme,
} from "@mui/material";

import { RHFRadioSingle } from "@app/components";
import { Strings } from "@app/constants";
import { Icon } from "@iconify/react";

import { YearsFiltersProps } from "../../types";

const YearFilter = ({ years }: YearsFiltersProps) => {
  const theme = useTheme();
  const [drawerOpen, setDrawerOpen] = useState(true);
  return (
    <Stack sx={{ py: 1 }}>
      <Stack
        flexDirection={"row"}
        justifyContent={"space-between"}
        onClick={() => setDrawerOpen(!drawerOpen)}
      >
        <Typography variant="subtitle1">{Strings.filters.year}</Typography>
        <IconButton size="small">
          {drawerOpen ? (
            <Icon icon="mdi:chevron-up" width={20} height={20} />
          ) : (
            <Icon icon="mdi:chevron-down" width={20} height={20} />
          )}
        </IconButton>
      </Stack>
      <Collapse in={drawerOpen}>
        {years.map((year) => (
          <RHFRadioSingle
            name="year"
            key={year}
            value={year}
            label={year}
            sx={{ "&.Mui-checked": { color: theme.palette.primary.main } }}
          />
        ))}
      </Collapse>
    </Stack>
  );
};

export { YearFilter };
